import React, { useState } from 'react';
import { Form, useForm } from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import ModalDialog from '../../../components/organisms/ModalDialog/ModalDialog';
import { useDelayed } from '../../../hooks/useDelayed';
import { TicketBookingForm } from './TicketBookingEditPartial';
import { useRefreshView } from '../../../_lib/ViewFetcher';
import { MultiStepForm } from '../../../components/molecules/Form/components/MultiStepForm';
import { TicketAddModalSubmitButton } from './TicketAddModalSubmitButton';
import { TicketModalMultiStepFormTimeFrameStep } from './TicketModalMultiStepFormTimeFrameStep';
import { TicketModalMultiStepFormPersonStep } from './TicketModalMultiStepFormPersonStep';
import { TicketModalMultiStepFormCheckListStep } from './TicketModalMultiStepFormCheckListStep';
import { ModalDialogModifier } from '../../../components/organisms/ModalDialog/ModalDialog';
import { Form2Modifier } from '../../../_lib/Form2/Form';

type TicketAddModal = {
  closeModal: () => void;
  form: TicketBookingForm;
};

export function TicketAddModal({ closeModal, form }: TicketAddModal) {
  const { t } = useSonTranslation('TicketBooking');
  const { delayedRefreshView } = useRefreshView();
  const [showCheckListTable, setShowCheckListTable] = useState(false);

  const delayedCloseModal = useDelayed(closeModal);

  const { formProps, fetchState, params } = useForm({
    form,
    onSuccess: () => {
      delayedRefreshView();
      delayedCloseModal();
    },
  });

  const dateRange = params.getByName('daterange');
  const timeRange = params.getByName('timerange');
  const weekDays = params.getAllByType('checkbox');
  const durationMinutes = params.getByName('durationMinutes');
  const parallelTickets = params.getByName('parallelTickets');
  const supplierUserId = params.getByName('supplierUserId');
  const firstToBeNotified = params.getByName('firstToBeNotifiedUserId');
  const secondToBeNotified = params.getByName('secondToBeNotifiedUserId');
  const checkListTemplateInputParam = params.getByName('checkListItem');

  return (
    <ModalDialog
      modifier={ModalDialogModifier.MEDIUM}
      closeModal={closeModal}
      headline={t(`edit.modalTitle`)}
      initialFocusIndex={1}
    >
      <Form id="create-ticket-form" {...formProps} modifier={Form2Modifier.NO_PADDING}>
        <MultiStepForm initialActiveTab="ticket-add-modal-form-timeframe">
          <TicketModalMultiStepFormTimeFrameStep
            stepId="ticket-add-modal-form-timeframe"
            dateRange={dateRange}
            weekDays={weekDays}
            timeRange={timeRange}
            parallelTickets={parallelTickets}
            durationMinutes={durationMinutes}
          />
          <TicketModalMultiStepFormPersonStep
            supplierUserId={supplierUserId}
            firstToBeNotified={firstToBeNotified}
            secondToBeNotified={secondToBeNotified}
            fetchState={fetchState}
            showCheckListTable={showCheckListTable}
            setShowCheckListTable={setShowCheckListTable}
          />
          {showCheckListTable ? (
            <TicketModalMultiStepFormCheckListStep
              checkListTemplateInputParam={checkListTemplateInputParam}
              submitButton={<TicketAddModalSubmitButton fetchState={fetchState} />}
            />
          ) : null}
        </MultiStepForm>
      </Form>
    </ModalDialog>
  );
}
